import React, { useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';

import { AuthProvider } from '../context/AuthContext';
import PageHeader from '../Components/PageHeader';
import PageFooter from '../Components/PageFooter';
import Home       from '../Components/Home';
import Pricing    from '../Components/Pricing';
import PrivacyPolicy from '../Components/PrivacyPolicy';
import ToS from '../Components/ToS';
import AboutUs from '../Components/AboutUs';
import Contact from '../Components/Contact';
import Blog from '../Components/Blog';
import BlogPost1 from '../Components/BlogPost1';
import BlogPost2 from '../Components/BlogPost2';
import BlogPost3 from '../Components/BlogPost3';
import Careers from '../Components/Careers';
import HelpCenter from '../Components/HelpCenter';
import Changelog from '../Components/Changelog';
import Dashboard from '../Components/Dashboard';
import Login from '../Components/Login';
import Signup from '../Components/Signup';
import OAuthCallback from '../Components/OAuthCallback';
import ProtectedRoute from '../Components/ProtectedRoute';
import Onboarding from '../Components/Onboarding';
import BillingPage from '../Components/BillingPage';
import GmailCallback from '../Components/GmailCallback';
import Settings from '../Components/Settings';

import './App.css';




function App() {
  useEffect(() => {
    // Carousel functionality
    const carousel = document.querySelector('.testimonial-carousel');
    const cards = document.querySelectorAll('.testimonial-card');
    const dots = document.querySelectorAll('.dot');
    const prevBtn = document.querySelector('.prev-btn');
    const nextBtn = document.querySelector('.next-btn');
    
    if (carousel && cards.length && dots.length && prevBtn && nextBtn) {
      let cardIndex = 0;
      const cardWidth = cards[0].offsetWidth + 30; 
      
      // Set the initial position
      carousel.style.transform = `translateX(0)`;
      
      // Handle next button click
      nextBtn.addEventListener('click', () => {
        if (cardIndex < cards.length - 1) {
          cardIndex++;
          updateCarousel();
        }
      });
      
      // Handle previous button click
      prevBtn.addEventListener('click', () => {
        if (cardIndex > 0) {
          cardIndex--;
          updateCarousel();
        }
      });
      
      // Handle dot navigation
      dots.forEach((dot, index) => {
        dot.addEventListener('click', () => {
          cardIndex = index;
          updateCarousel();
        });
      });
      
      // Update carousel position and active dot
      function updateCarousel() {
        carousel.style.transform = `translateX(-${cardIndex * cardWidth}px)`;
        
        // Update active dot
        dots.forEach((dot, index) => {
          if (index === cardIndex) {
            dot.classList.add('active');
          } else {
            dot.classList.remove('active');
          }
        });
        
        // Update button states
        prevBtn.style.opacity = cardIndex === 0 ? '0.5' : '1';
        nextBtn.style.opacity = cardIndex === cards.length - 1 ? '0.5' : '1';
      }
    }
  }, []);

  const location = useLocation();
  const isDashboard = location.pathname === '/dashboard' || location.pathname === '/onboarding' || location.pathname === '/settings';

  return (
    <AuthProvider>
      <div className="app-container">
        <div className="container">

          {!isDashboard && <PageHeader />}

          <Routes>
            <Route path="/"       element={<Home />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-of-service" element={<ToS />} />
            <Route path="/about" element={<AboutUs />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/applyai-1000-students" element={<BlogPost1 />} />
            <Route path="/blog/cold-email-templates" element={<BlogPost2 />} />
            <Route path="/blog/ai-cover-letters" element={<BlogPost3 />} />
            <Route path="/careers" element={<Careers />} />
            <Route path="/help" element={<HelpCenter />} />
            <Route path="/changelog" element={<Changelog />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/auth/callback" element={<OAuthCallback />} />
            <Route path="/onboarding" element={<ProtectedRoute><Onboarding onComplete={() => window.location.href = '/dashboard'} /></ProtectedRoute>} />
            <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            <Route path="/billing" element={<BillingPage />} />
            <Route path="/gmail/callback" element={<GmailCallback />} />
            <Route path="/settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />
          </Routes>

          {!isDashboard && <PageFooter />}

        </div>
      </div>
    </AuthProvider>
  );
}

export default App;
